/**
 * Footer R3NU — viewport entrance for inner content (staggered in CSS).
 * Uses visible-height fraction (not IO ratio >= 0.5) so tall footers can reveal.
 */
(function () {
  var SEL = '.footer-r3nu--intro-reveal';

  function revealApi() {
    return window.R3NU && window.R3NU.reveal ? window.R3NU.reveal : null;
  }

  function shouldRevealGeometry(el, entry) {
    var api = revealApi();
    if (api) return api.shouldReveal(el, entry);
    return entry && entry.isIntersecting;
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function detachListeners(root) {
    if (root._footerR3nuIntroRevealIO) {
      root._footerR3nuIntroRevealIO.disconnect();
      root._footerR3nuIntroRevealIO = null;
    }
    if (root._footerR3nuIntroRevealOnScroll) {
      window.removeEventListener('scroll', root._footerR3nuIntroRevealOnScroll, { capture: true });
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('scroll', root._footerR3nuIntroRevealOnScroll);
      }
      root._footerR3nuIntroRevealOnScroll = null;
    }
    if (root._footerR3nuIntroRevealOnResize) {
      window.removeEventListener('resize', root._footerR3nuIntroRevealOnResize);
      root._footerR3nuIntroRevealOnResize = null;
    }
  }

  function reveal(root) {
    root.classList.add('footer-r3nu--intro-revealed');
    detachListeners(root);
  }

  function teardown(root) {
    detachListeners(root);
  }

  function init(root) {
    if (!root || root.dataset.footerR3nuIntroRevealInit) return;
    root.dataset.footerR3nuIntroRevealInit = 'true';

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      reveal(root);
      return;
    }

    if (prefersReducedMotion()) {
      reveal(root);
      return;
    }

    if (root.classList.contains('footer-r3nu--intro-revealed')) return;

    if (root.offsetHeight < 1) {
      reveal(root);
      return;
    }

    var api = revealApi();
    var rootMargin = api ? api.getRootMargin() : '0px 0px 12% 0px';
    var thresholdList = api ? api.buildThresholdList() : [0, 0.1, 0.2, 0.5, 1];

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== root) return;
          if (shouldRevealGeometry(root, entry)) reveal(root);
        });
      },
      { threshold: thresholdList, rootMargin: rootMargin }
    );
    io.observe(root);
    root._footerR3nuIntroRevealIO = io;

    function onResize() {
      if (root.classList.contains('footer-r3nu--intro-revealed')) return;
      if (shouldRevealGeometry(root, null)) reveal(root);
    }
    root._footerR3nuIntroRevealOnResize = onResize;
    window.addEventListener('resize', onResize, { passive: true });

    function onScrollRaf() {
      if (root.classList.contains('footer-r3nu--intro-revealed')) return;
      requestAnimationFrame(function () {
        if (root.classList.contains('footer-r3nu--intro-revealed')) return;
        try {
          if (root._footerR3nuIntroRevealIO) {
            root._footerR3nuIntroRevealIO.takeRecords().forEach(function (entry) {
              if (entry.target === root && shouldRevealGeometry(root, entry)) reveal(root);
            });
          }
        } catch (e) {}
        if (!root.classList.contains('footer-r3nu--intro-revealed') && shouldRevealGeometry(root, null)) {
          reveal(root);
        }
      });
    }
    root._footerR3nuIntroRevealOnScroll = onScrollRaf;
    window.addEventListener('scroll', onScrollRaf, { passive: true, capture: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('scroll', onScrollRaf, { passive: true });
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (root.classList.contains('footer-r3nu--intro-revealed')) return;
        if (shouldRevealGeometry(root, null)) reveal(root);
      });
    });
  }

  function destroy(root) {
    delete root.dataset.footerR3nuIntroRevealInit;
    teardown(root);
  }

  function scan(scope) {
    var s = scope || document;
    s.querySelectorAll(SEL).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelectorAll) scan(ev.target);
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    var t = ev.target;
    if (!t) return;
    var el = t.matches && t.matches(SEL) ? t : t.querySelector(SEL);
    if (el) destroy(el);
  });

  function syncFooterR3nuInView() {
    document.querySelectorAll(SEL).forEach(function (root) {
      if (!root.dataset.footerR3nuIntroRevealInit) return;
      if (root.classList.contains('footer-r3nu--intro-revealed')) return;
      var io = root._footerR3nuIntroRevealIO;
      if (io) {
        try {
          io.takeRecords().forEach(function (entry) {
            if (entry.target === root && shouldRevealGeometry(root, entry)) reveal(root);
          });
        } catch (e) {}
      }
      if (root.classList.contains('footer-r3nu--intro-revealed')) return;
      if (shouldRevealGeometry(root, null)) {
        reveal(root);
      }
    });
  }

  if (window.r3nuRegisterViewportRecheck) {
    window.r3nuRegisterViewportRecheck(syncFooterR3nuInView);
  }
})();
